// GENERATED FILE — do not edit by hand.
// Run `npm --workspace web run i18n:generate` (or
// `node scripts/generate-i18n-resources.mjs`) after adding, renaming or
// removing a locale directory or a namespace JSON file under `locales/`.
//
// Static imports on purpose: this module is bundled by esbuild for the
// design-system export as well as by Vite, and `import.meta.glob` only
// exists in Vite (DUE-260). See scripts/generate-i18n-resources.mjs.

import type { Resource } from "i18next";

import en_admin from "./locales/en/admin.json";
import en_archetype from "./locales/en/archetype.json";
import en_common from "./locales/en/common.json";
import en_errors from "./locales/en/errors.json";
import en_forms from "./locales/en/forms.json";
import en_friends from "./locales/en/friends.json";
import en_mood from "./locales/en/mood.json";
import en_onboarding from "./locales/en/onboarding.json";
import en_payments from "./locales/en/payments.json";
import en_states from "./locales/en/states.json";
import en_support from "./locales/en/support.json";
import en_synastry from "./locales/en/synastry.json";
import en_today from "./locales/en/today.json";
import en_you from "./locales/en/you.json";
import es_admin from "./locales/es/admin.json";
import es_archetype from "./locales/es/archetype.json";
import es_common from "./locales/es/common.json";
import es_errors from "./locales/es/errors.json";
import es_forms from "./locales/es/forms.json";
import es_friends from "./locales/es/friends.json";
import es_mood from "./locales/es/mood.json";
import es_onboarding from "./locales/es/onboarding.json";
import es_payments from "./locales/es/payments.json";
import es_states from "./locales/es/states.json";
import es_support from "./locales/es/support.json";
import es_synastry from "./locales/es/synastry.json";
import es_today from "./locales/es/today.json";
import es_you from "./locales/es/you.json";
import pt_admin from "./locales/pt/admin.json";
import pt_archetype from "./locales/pt/archetype.json";
import pt_common from "./locales/pt/common.json";
import pt_errors from "./locales/pt/errors.json";
import pt_forms from "./locales/pt/forms.json";
import pt_friends from "./locales/pt/friends.json";
import pt_mood from "./locales/pt/mood.json";
import pt_onboarding from "./locales/pt/onboarding.json";
import pt_payments from "./locales/pt/payments.json";
import pt_states from "./locales/pt/states.json";
import pt_support from "./locales/pt/support.json";
import pt_synastry from "./locales/pt/synastry.json";
import pt_today from "./locales/pt/today.json";
import pt_you from "./locales/pt/you.json";
import ru_admin from "./locales/ru/admin.json";
import ru_archetype from "./locales/ru/archetype.json";
import ru_common from "./locales/ru/common.json";
import ru_errors from "./locales/ru/errors.json";
import ru_forms from "./locales/ru/forms.json";
import ru_friends from "./locales/ru/friends.json";
import ru_mood from "./locales/ru/mood.json";
import ru_onboarding from "./locales/ru/onboarding.json";
import ru_payments from "./locales/ru/payments.json";
import ru_states from "./locales/ru/states.json";
import ru_support from "./locales/ru/support.json";
import ru_synastry from "./locales/ru/synastry.json";
import ru_today from "./locales/ru/today.json";
import ru_you from "./locales/ru/you.json";

/** Locale directories under `locales/`. `index.ts` asserts these are the
 * locales the product supports. */
export const GENERATED_LOCALES = ["en", "es", "pt", "ru"] as const;

/** Namespace files every locale ships. Exported as `I18N_NAMESPACES`. */
export const GENERATED_NAMESPACES = [
  "admin",
  "archetype",
  "common",
  "errors",
  "forms",
  "friends",
  "mood",
  "onboarding",
  "payments",
  "states",
  "support",
  "synastry",
  "today",
  "you",
] as const;

export const resources: Resource = {
  en: {
    admin: en_admin,
    archetype: en_archetype,
    common: en_common,
    errors: en_errors,
    forms: en_forms,
    friends: en_friends,
    mood: en_mood,
    onboarding: en_onboarding,
    payments: en_payments,
    states: en_states,
    support: en_support,
    synastry: en_synastry,
    today: en_today,
    you: en_you,
  },
  es: {
    admin: es_admin,
    archetype: es_archetype,
    common: es_common,
    errors: es_errors,
    forms: es_forms,
    friends: es_friends,
    mood: es_mood,
    onboarding: es_onboarding,
    payments: es_payments,
    states: es_states,
    support: es_support,
    synastry: es_synastry,
    today: es_today,
    you: es_you,
  },
  pt: {
    admin: pt_admin,
    archetype: pt_archetype,
    common: pt_common,
    errors: pt_errors,
    forms: pt_forms,
    friends: pt_friends,
    mood: pt_mood,
    onboarding: pt_onboarding,
    payments: pt_payments,
    states: pt_states,
    support: pt_support,
    synastry: pt_synastry,
    today: pt_today,
    you: pt_you,
  },
  ru: {
    admin: ru_admin,
    archetype: ru_archetype,
    common: ru_common,
    errors: ru_errors,
    forms: ru_forms,
    friends: ru_friends,
    mood: ru_mood,
    onboarding: ru_onboarding,
    payments: ru_payments,
    states: ru_states,
    support: ru_support,
    synastry: ru_synastry,
    today: ru_today,
    you: ru_you,
  },
};
